import { Box, Typography, Grid, Button } from "@material-ui/core";
import { observer } from "mobx-react";
import { useACHFormStore } from "../hooks/useACHStore";
import { useRef, useState } from "react";
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Paper, PaperBorderType, } from '@roc/ui';
import { formatDate } from '@roc/feature-utils';
import SignatureCanvas from 'react-signature-canvas';
import { useBorrowerPortalMediaQueries } from "@roc/feature-app-core";
import { TitleComp } from "libs/feature-borrowers/src/caf/components/titleComp";

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      alignItems: 'center',
      marginTop: '20px'
    },
    button: {
      width: '160px',
      marginBottom: '50px'
    },
    margins: {
      marginTop: '20px'
    },
    sigCanvas: {
      width: "100%",
      height: 200,
      background: "#f7f7f7",
      border: "1px solid #aaa",
      borderRadius: 16,
    },
  };
});

export const DocusignACHIframe = observer(() => {
  const { achFormStore } = useACHFormStore();
  const classes = useStyles();
  const { isLargeScreen } = useBorrowerPortalMediaQueries();
  const sigCanvas = useRef(null);
  const [signed, setSigned] = useState(false);

  const generateDocument = () => {
    const signatureURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    achFormStore.generateDocument(signatureURL);
  }

  return (
    <Box pb={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Grid xs={12}>
            <Box mb={1}>
              <TitleComp title="Acknowledgments" />
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Grid item xs={12}>
            <Box mb={3}>
              <Paper variant="outlined" style={{ maxHeight: isLargeScreen ? 300 : 150, overflowY: "auto", padding: 24, borderColor: '#ccc' }} borderType={PaperBorderType.SOLID_BORDER}>
                <Typography variant="body1" style={{
                  fontStyle: 'italic'
                }}>
                  <ul style={{ marginLeft: '16px' }}>
                    <li style={{ marginBottom: '12px' }}>I acknowledge that should the recurring monthly payment date fall on a weekend or holiday,
                      the payment will be withdrawn on the next applicable business day.</li>
                    <li style={{ marginBottom: '12px' }}>I acknowledge that any payment not made within the applicable grace period (1st to 10th of
                      each month) may be subject to fees.</li>
                    <li style={{ marginBottom: '12px' }}>I acknowledge that the completion of this form gives authority to lender, servicer and any of its
                      affiliates to perform electronic transfers from the account listed herein.</li>

                    <li style={{ marginBottom: '12px' }}>I acknowledge that payments will only be deducted if the loan is current.</li>
                    <li style={{ marginBottom: '12px' }}>I acknowledge that if, at any time, the withdrawal is not successful due to lack of available
                      funds, lender, servicer and any of its affiliates may terminate this agreement.</li>

                    <li style={{ marginBottom: '12px' }}>I acknowledge that a fee for insufficient funds (NSF) may be applied.</li>
                    <li style={{ marginBottom: '12px' }}>I acknowledge that I remain responsible for timely payments throughout the life of the loan.</li>
                    <li style={{ marginBottom: '12px' }}>I acknowledge that my monthly debit amount may change pursuant to the terms of my loan.</li>
                    <li >Borrower reserves the right to terminate this agreement so long as lender, servicer or its
                      affiliates receives timely written notification, and has an opportunity to act.</li>
                  </ul>
                </Typography>
              </Paper>
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Grid xs={12}>
            <Box my={3}>
              <TitleComp title={<span>Borrower Signature<Box color="red" component={"span"} ml={.5}>*</Box></span>} />
            </Box>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <SignatureCanvas penColor='green'
                canvasProps={{ className: classes.sigCanvas }}
                ref={sigCanvas}
                onEnd={() => setSigned(true)} />
              <Box display={'flex'} justifyContent={'space-between'} width="100%">
                <Button size="small" onClick={() => {
                  const dataURL = sigCanvas.current.toDataURL("image/png");
                  console.log(dataURL);
                  sigCanvas.current.clear();
                  setSigned(false);
                }}>Clear</Button>
                <Box color={'blue'}>
                  {formatDate(new Date())}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => generateDocument()}
              disabled={!signed || sigCanvas.current?.isEmpty()}
            >
              SUBMIT
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
});